import React from 'react';
import ArrayHelper from 'foundation/array-helper';
import classNames from 'classnames';
import { getRoundById, checkIfRoundHasTeeTimes } from 'general/js/helpers';
import LeaderboardRowTitle from './leaderboard-row-title';
import LeaderboardRows from './leaderboard-rows';

const LeaderboardTable = ({
    options,
    scoringCourse,
    currentRound,
    deviceTypeByViewport,
    players,
    playersCut,
    favoritePlayers,
    favoriteState,
    activeRoundId,
    toggleRScore,
    sortingHandlerProps,
    processingState,
    liveScanner,
    ...rest
}) => {
    const scoringCourseRound = getRoundById(scoringCourse.courseRounds, currentRound);

    if (!scoringCourseRound || ArrayHelper.isEmpty(scoringCourseRound.holePars)) return null;

    const hasTeeTime = checkIfRoundHasTeeTimes(players);

    const stateCss = classNames({
        'is-active-mobile': !hasTeeTime
    });

    return (
        <div className={`leaderboard__table ${stateCss}`}>
            <LeaderboardRowTitle
                scoringCourseRound={scoringCourseRound}
                toggleRScore={toggleRScore}
                sortingHandlerProps={sortingHandlerProps}
                processingState={processingState}
                currentRound={currentRound}
                {...rest}
            />
            <LeaderboardRows
                options={options}
                scoringCourseRound={scoringCourseRound}
                currentRound={currentRound}
                deviceTypeByViewport={deviceTypeByViewport}
                players={players}
                playersCut={playersCut}
                favoritePlayers={favoritePlayers}
                favoriteState={favoriteState}
                activeRoundId={activeRoundId}
                liveScanner={liveScanner}
                {...rest}
            />
        </div>
    );
};

export default LeaderboardTable;
